import { buildSlice, CommonState } from '~libs/reduxUtils';

import { getAll, getOne, typePrefix } from '~main/actions/formDefaults';

export interface FormDefault {
  id: string;
  feature_tag: string;
  feature_type: string;
  key: string;
  value?: string;
}

const initialState: CommonState<FormDefault> = {
  loading: 'idle',
  hasLoaded: false,
  error: null,
  rows: [],
};

const slice = buildSlice<CommonState<FormDefault>, FormDefault>(typePrefix, initialState, {
  commonConfig: { getAll, getOne },
});

export const { clear, updateParams } = slice.actions;
export default slice.reducer;
